import React from 'react';

function GlobalStandards() {
    return (
        <div id='global-standards' className='--align py-10 lg:py-[95px]'>
            <div className='md:flex md:justify-between md:items-center'>
                <div className='md:w-[50%] lg:w-[44%]'>
                    <img className='w-full md:w-full' src="/Home/GlobalStandards.svg" alt="GlobalStandards" loading='lazy'/>
                </div>

                <div className='mt-[20px] md:w-[40%] lg:w-[48%]'>
                    <h5 className='text-dark-saffron text-[24px] font-semibold lg:text-[36px] font-[600]'>Global Quality Standards</h5>

                    <p className='text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]'>
                        In today’s situation, one bad batch can cost you millions of dollars. And lose the trust of 
                        your precious customers. APIdrug, in partnership with SGS and Intertek, tests the products 
                        upfront in labs with global quality standards. We verify all documents provided by the suppliers. 
                        So that you NEVER have to worry about the quality and reliability of the products.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default GlobalStandards